/*
Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.

Licensed under the Apache License, Version 2.0 (the "License").
You may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
import { getStore } from '../../reducers';
import { getAccessToken } from '../requestHelper';
import { sleep } from '../utils';

const getWebSocketUrl = async () => {
  const state = getStore().getState();
  const instanceId = state.auth.instanceId;
  const wsHost = state.app.appParam.ink_ai_ws_endpoint;
  const accessToken = await getAccessToken('id');
  return `${wsHost}?instanceId=${instanceId}&token=${accessToken}`;
};

export const getSocketConnection = async () => {
  let connection = new WebSocket(await getWebSocketUrl());
  while (connection?.readyState !== WebSocket.OPEN) {
    switch (connection?.readyState) {
      case undefined:
      case WebSocket.CLOSED:
      case WebSocket.CLOSING:
        // closed, retry after 5 sec
        await sleep(5000);
        connection = new WebSocket(await getWebSocketUrl());
        break;
      case WebSocket.CONNECTING:
        // connecting, check after 500ms
        await sleep(500);
        break;
      default:
        break;
    }
  }
  return connection;
};
